<template>
  <!-- modalTheme {{ modalTheme }} -->
  <div v-if="workListStore.primaryWidgetSummaryList.length > 0">
    <h4 v-if="AreIdsShown">workListStore.currentSelectedSummaryWidget {{ workListStore.currentSelectedSummaryWidget.id }}</h4>
    <!-- <div v-if="primaryWidgetSummaryList.length > 0">HAS </div> -->
    <!-- primaryWidgetSummaryList {{ workListStore.primaryWidgetSummaryList }} -->
    <!-- <h3 class="title is-6" style="background:darkblue;color:cyan;">currentSelectedSummaryWidget :    {{ currentSelectedSummaryWidget }}</h3> -->
    <b-form-tags
      :class="modalTheme"
      v-model="workListStore.primaryWidgetSummaryList"
      no-outer-focus
      class="mb-0"
      tag-pills
      size="xs"
      style="background: transparent; height: 100%; padding: 00px; padding-top: 0px"
    >
      <!-- <span>style="background:#B0C1B2;padding:0px;padding-top:-0px;"</span> -->

      <template v-slot="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
        <h5 v-if="AreIdsShown" class="title is-6" style="background: darkred; color: yellow">
          workListStore.currentSelectedSummaryWidget : {{ workListStore.currentSelectedSummaryWidget.id }} {{ workListStore.currentSelectedSummaryWidget.name }}
        </h5>

        <!-- 3a; padding:6px;height:100%;border-radius:12.5px;">
          <PrimaryWidgetThumbChart :widgetType="currentSelectedSummaryWidget.widgetType"/>
        </div> -->
        <div id="my-custom-tags-list" class="list-unstyled d-inline-flex flex-wrap mb-0 mt-0" aria-live="polite" aria-atomic="false" aria-relevant="additions removals">
          <b-input-group aria-controls="my-custom-tags-list">
            <!-- ? OFF  INPUT TO ADD to ARRAY  is   OFF  -->
            <!-- <b-form-input id="input-sm" size="sm" type="text" v-bind="inputAttrs" v-on="inputHandlers"
              placeholder="New tag - Press enter to add" name="title" class="form-control"
              :class="{ 'is-invalid': !inputAttrs }"></b-form-input>
            <b-input-group-append>
              <b-button @click="addTag()" variant="primary" size="sm">Add</b-button>
            </b-input-group-append> -->
          </b-input-group>
          <!-- <b-card-group deck> -->
          <!-- <h6 style="color:lime;"> tags {{tags}}</h6> -->
          <!-- <Widget v-for="(msg, index) in tags" :msg="msg" :key="index" class="panel-container" /> -->
          <!-- {{ tags[5] }} -->
          <!-- <div v-if="tag.id !== 6" style="color:yellow;">TEST</div> -->
          <div
            v-for="tag in tags"
            :key="tag"
            :id="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
            tag="div"
            class="mt-0 mr-0"
            body-class="py-0 pr-0 text-nowrap"
            style="background: transparent; color: transparent; padding: 6px; overflow: auto; max-height: 80vh"
          >
            <!-- <span> style="background:#B0C1B2;background:red;color:cyan;padding:6px;overflow:auto:max-height:80vh; width:200px;"</span> -->

            <h6 v-if="![11].includes(workListStore.currentSelectedSummaryWidget.id) && AreIdsShown">
              <!-- {{ tag }} -->
              {{ JSON.parse(tag).id }} {{ JSON.parse(tag).name }}
            </h6>
            <!-- <h3 style="color: yellow">{{ JSON.parse(tag).id }}</h3> -->
            <b-button :class="modalTheme" @click="showTagINFO(tag)" size="sm" variant="dark-blue">
              <b-col style="padding: 0px">
                <h6>{{ JSON.parse(tag).name }}</h6>
              </b-col>
              <b-col style="padding: 0px">
                <PrimaryWidgetBarChart
                  v-if="JSON.parse(tag).id == '11'"
                  :widgetData="JSON.parse(tag)"
                  :widget="workListStore.currentSelectedSummaryWidget"
                  :widgetType="workListStore.currentSelectedSummaryWidget.widgetType"
                />
                <PrimaryWidgetThumbChart
                  v-else
                  :widgetData="JSON.parse(tag)"
                  :widget="workListStore.currentSelectedSummaryWidget"
                  :widgetType="workListStore.currentSelectedSummaryWidget.widgetType"
                />
              </b-col>
            </b-button>
            <b-button v-if="AreIdsShown" aria-keyshortcuts="Delete" type="button" aria-label="Remove tag" variant="primary" class="close b-form-tag-remove" @click="removeTag(tag)" size="sm">
              <b-badge style="background: rgba(255, 0, 0, 0.695); color: white">x</b-badge>
            </b-button>
            <!-- v-b-toggle.collapse-2
          <b-collapse id="collapse-2">
            <b-card>I am collapsible content!</b-card>
          </b-collapse> -->
            <!-- <button
            @click="removeTag(tag)"
            class="close b-form-tag-remove"
            variant="link"
            size="sm"
            :aria-controls="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
          >xXx</button> -->
            <!-- <Widget :msg="tag" :key="tag" :id="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`" tag="card"
  class="panel-container my-custom-tags-list" /> -->
          </div>
        </div>
      </template>
    </b-form-tags>
    <!-- <p>
      {{ label }}
      <span @click="editing = true" v-show="!editing">
        {{ value }}
      </span>
      <span v-show="editing">
        <input :value="value" @input="$emit('input', $event.target.value)" @keydown.enter="editing = false" type="text"
          class="form-control">
      </span>
    </p> -->
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
import { useStoreWorkList } from "@/stores/workListsStore";
const workListStore = useStoreWorkList();

import PrimaryWidgetThumbChart from "./PrimaryWidgetThumbChart.vue";
import PrimaryWidgetBarChart from "./PrimaryWidgetBarChart.vue";

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(false);

async function showTagINFO(e) {
  // console.clear()
// console.log(" >> SHOW TAG INFO");
// console.log(" STORE SET Mut 					setSelectedSummaryWidget  ");

  workListStore.setSelectedSummaryWidget(e);

// console.log("**************t his.currentSelectedSummaryWidget **************************************************************************************************");
// console.log(workListStore.currentSelectedSummaryWidget);

  if (workListStore.currentSelectedSummaryWidget.id === 11) {
// console.log(" NEW  STORE SET Mut 			 SET fix FROM  Id = 11											setWidgetArray  ");

    // workListStore.currentSelectedSummaryWidget.widgetGridDataArray[0].contractMeasureSummaries
// console.log("workListStore.currentSelectedSummaryWidget.widgetGridDataArray[0].contractMeasureSummaries");
// console.log(workListStore.currentSelectedSummaryWidget.widgetGridDataArray[0].contractMeasureSummaries.length); // ST set
    // this.$store.commit( //   "setWidgetArray", //   this.currentSelectedSummaryWidget.widgetGridDataArray[0].contractMeasureSummaries // );
    workListStore.setWidgetArray(workListStore.currentSelectedSummaryWidget.widgetGridDataArray[0].contractMeasureSummaries);
  } else {
// console.log();
// console.log("OFF  currentSelectedSummaryWidget    if dueText L == 0   USE LOCAL ARRAY for COLORS to SET Master ONLYL tempWidgetdueTextSummary ");
    // console.log('ON  currentSelectedSummaryWidget    i(this.currentSelectedSummaryWidget.dueTextSummary.length === 0)&& (this.currentSelectedSummaryWidget.id === 1)   DROPPED HCC CODES byId                  USE LOCAL ARRAY for COLORS to SET Master ONLYL tempWidgetdueTextSummary ')

    // if
    // ((this.currentSelectedSummaryWidget.dueTextSummary.length === 0)&& (this.currentSelectedSummaryWidget.id === 1))  {
    //     console.log('    LENGTH 0')
    //     this.currentSelectedSummaryWidget.dueTextSummary = this.tempWidgetdueTextSummary
    // }

// console.log("currentSelectedSummaryWidget dueTextSummary : ");
// console.log(workListStore.currentSelectedSummaryWidget.dueTextSummary);

// console.log("****************************************************************************************************************");
    // console.log(' STORE SET Mut 		CHECK for 11						  ')
    // // ST set
    // this.$store.commit('setSelectedSummaryWidgetDetail', dDetail)

// console.log(" NEW  STORE SET Mut 														setWidgetArray  ");
    // ST set
    // this.$store.commit(
    //   "setWidgetArray",
    //   workListStore.currentSelectedSummaryWidget.widgetGridDataArray
    // );
    workListStore.setWidgetArray(workListStore.currentSelectedSummaryWidget.widgetGridDataArray);
  }
}
async function showTagINFOold(e) {
  // console.clear()
// console.log(" >> SHOW TAG INFO");
// console.log(" STORE SET Mut 					setSelectedSummaryWidget  ");

  workListStore.setSelectedSummaryWidget(e);

// console.log("**************t his.currentSelectedSummaryWidget **************************************************************************************************");
// console.log(workListStore.currentSelectedSummaryWidget);

  if (workListStore.currentSelectedSummaryWidget.id === 11) {
// console.log(" NEW  STORE SET Mut 			 SET fix FROM  Id = 11											setWidgetArray  ");

    // workListStore.currentSelectedSummaryWidget.widgetGridDataArray[0].contractMeasureSummaries
// console.log("workListStore.currentSelectedSummaryWidget.widgetGridDataArray[0].contractMeasureSummaries");
// console.log(workListStore.currentSelectedSummaryWidget.widgetGridDataArray[0].contractMeasureSummaries.length); // ST set
    // this.$store.commit( //   "setWidgetArray", //   this.currentSelectedSummaryWidget.widgetGridDataArray[0].contractMeasureSummaries // );
    workListStore.setWidgetArray(workListStore.currentSelectedSummaryWidget.widgetGridDataArray[0].contractMeasureSummaries);
  } else {
// console.log();
// console.log("OFF  currentSelectedSummaryWidget    if dueText L == 0   USE LOCAL ARRAY for COLORS to SET Master ONLYL tempWidgetdueTextSummary ");
    // console.log('ON  currentSelectedSummaryWidget    i(this.currentSelectedSummaryWidget.dueTextSummary.length === 0)&& (this.currentSelectedSummaryWidget.id === 1)   DROPPED HCC CODES byId                  USE LOCAL ARRAY for COLORS to SET Master ONLYL tempWidgetdueTextSummary ')

    // if
    // ((this.currentSelectedSummaryWidget.dueTextSummary.length === 0)&& (this.currentSelectedSummaryWidget.id === 1))  {
    //     console.log('    LENGTH 0')
    //     this.currentSelectedSummaryWidget.dueTextSummary = this.tempWidgetdueTextSummary
    // }

// console.log("currentSelectedSummaryWidget dueTextSummary : ");
// console.log(workListStore.currentSelectedSummaryWidget.dueTextSummary);

// console.log("****************************************************************************************************************");
    // console.log(' STORE SET Mut 		CHECK for 11						  ')
    // // ST set
    // this.$store.commit('setSelectedSummaryWidgetDetail', dDetail)

// console.log(" NEW  STORE SET Mut 														setWidgetArray  ");
    // ST set
    // this.$store.commit(
    //   "setWidgetArray",
    //   workListStore.currentSelectedSummaryWidget.widgetGridDataArray
    // );
    workListStore.setWidgetArray(workListStore.currentSelectedSummaryWidget.widgetGridDataArray);
  }
}

onMounted(() => {
// console.log("onMounted() :      WidgetSummaryListPrimary >>>>");
});
</script>

<style lang="scss" scoped>
#pie {
  height: 550px;
}

#pieGroup {
  height: 550px;
  background: darkred;
  padding: 0px;
}

.pies-container {
  margin: auto;
  //width: 460px;
  width: 100%;
  background: rgb(161, 83, 18);
  padding: 0px;
  overflow: auto;
  height: 30vh;
}

.pies-container > div {
  width: 100px;
  float: left;
  margin-top: -50px;
}

.long-title h3 {
  font-weight: 200;
  font-size: 28px;
  text-align: center;
  margin-bottom: 20px;
}
</style>
